<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */

    import CustomInteraction from '../../interactions/custom/CustomInteraction.svelte';
    import { getReadonlyCustomInteractionProps } from '../util/readonlyProps.js';

    let props = $props();

    let readonlyProps = $derived(getReadonlyCustomInteractionProps(props));
</script>

<CustomInteraction {...readonlyProps} />
